var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['richtext'],domProps:{"innerHTML":_vm._s(_vm.value || _vm.data.innerHTML)}})
}
var staticRenderFns = []

export { render, staticRenderFns }